import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";

const goToSerial = (serial) => {
  const url = new URL(window.location.href);
  url.searchParams.set("serial", serial);
  window.location.href = url.toString();
};

const Serialfetch = ({ companyName }) => {
  const [serials, setSerials] = useState([]);   // <-- start as []
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (companyName) fetchSerialList();
  }, [companyName]);

  const fetchSerialList = async () => {
    try {
      setError(null);
      setLoading(true);
      setSerials([]);

      const url = `https://fdl-service.azurewebsites.net/getSerial?company=${encodeURIComponent(companyName)}`;
      const response = await fetch(url);

      const text = await response.text();
      if (!response.ok) throw new Error(`HTTP ${response.status}: ${text}`);

      const data = JSON.parse(text);
      if (!Array.isArray(data.serials)) throw new Error(`"serials" is not an array`);

      setSerials(data.serials);
    } catch (err) {
      console.error("Error fetching serial JSON:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h3>Serial Links available</h3>

      {error && <p style={{ color: "red" }}>ERROR: {error}</p>}
      {loading && <p>Loading…</p>}

      {!loading && !error && serials.length === 0 && (
        <p>No serials found for {companyName}</p>
      )}

      <div className="d-flex flex-wrap gap-3 justify-content-center mt-3">
        {serials.map((s) => (
          <Button key={s} className="custom-button" onClick={() => goToSerial(s)}>
            {s}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default Serialfetch;
